module.exports = __webpack_public_path__ + "media/images/hero/hero-bg2-118c19a4cd2bd8dde1f337ad3c6e0ead.png";